import { watch } from 'vue';
import { useMediaQuery } from '@vueuse/core';

export const MOBILE_QUERY = '(max-width: 768px)';

export function viewportPlugin(options) {
  return (store) => {
    const mobile = useMediaQuery(MOBILE_QUERY, options);

    watch(mobile, (value) => store.commit('app/SET_MOBILE', value), {
      immediate: true,
      flush: 'sync',
    });
  };
}
